import React from 'react';
import { Box, Typography } from '@mui/material';
import { COPY } from '../presentationCopy';
import { PRES, TYPE } from '../chrome';
import PageKindInfo from './PageKindInfo';

const ProductLinkedBanner: React.FC = () => (
  <Box
    role="status"
    aria-label={COPY.productLinkedBanner}
    sx={{
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      px: 2,
      py: 0.75,
      bgcolor: '#e8eef8',
      color: PRES.interactive,
      borderBottom: `1px solid #c5d3ea`,
    }}
  >
    <Box sx={{ minWidth: 0, flex: 1 }}>
      <Typography sx={{
        fontFamily: TYPE.ui,
        ...TYPE.body,
        fontWeight: 650,
        color: PRES.interactive,
      }}>
        {COPY.productLinkedBanner}
      </Typography>
      <Typography sx={{
        fontFamily: TYPE.ui,
        ...TYPE.caption,
        color: PRES.textSecondary,
      }}>
        {COPY.productLinkedHelp}
      </Typography>
    </Box>
    <PageKindInfo text={COPY.pageKindProductInfo} tone="light" />
  </Box>
);

export default ProductLinkedBanner;
